<template>
  <div class="app-container">
    <div v-if="!hasPermission" class="no-permission">
      <i class="el-icon-warning-outline"></i>
      <h2>您没有权限访问此页面</h2>
      <p>请联系系统管理员获取权限</p>
    </div>

    <el-card v-else shadow="never" class="account-card">
      <div slot="header" class="card-header">
        <span>修改密码</span>
      </div>

      <el-form
        :model="updateForm"
        :rules="updateRules"
        ref="updateForm"
        label-width="100px"
        size="small"
        class="pwd-form"
      >
        <el-form-item label="用户名">
          <el-input :value="updateForm.username" disabled style="width: 320px;" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="updateForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
            style="width: 320px;"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmNewPassword">
          <el-input
            v-model="updateForm.confirmNewPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
            style="width: 320px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="updating" @click="handleUpdatePassword">确 定</el-button>
          <el-button @click="resetUpdateForm">重 置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
  name: 'AccountManagement',
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.updateForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      updating: false,
      updateForm: {
        username: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      updateRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmNewPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo'
    }),
    hasPermission() {
      try {
        return this.$store.getters['user/isLoggedIn']
      } catch (error) {
        return false
      }
    }
  },
  async created() {
    const userData = localStorage.getItem('userData')
    if (userData) {
      try {
        const parsedData = JSON.parse(userData)
        if (parsedData.userInfo && parsedData.userInfo.username) {
          this.updateForm.username = parsedData.userInfo.username
        }
      } catch (error) {
        this.$message.error('获取用户信息失败')
      }
    }
  },
  methods: {
    async handleUpdatePassword() {
      this.$refs.updateForm.validate(async (valid) => {
        if (!valid) return
        this.updating = true
        try {
          await request.put('/api/account', {
            username: this.updateForm.username,
            password: this.updateForm.newPassword
          })
          this.$message.success('密码修改成功')
          this.resetUpdateForm()
        } catch (error) {
          this.$message.error((error && error.message) || '密码修改失败，请重试')
        } finally {
          this.updating = false
        }
      })
    },
    resetUpdateForm() {
      let username = this.updateForm.username
      const userData = localStorage.getItem('userData')
      if (userData) {
        try {
          const parsedData = JSON.parse(userData)
          if (parsedData.userInfo && parsedData.userInfo.username) {
            username = parsedData.userInfo.username
          }
        } catch (error) {
          // 忽略本地用户信息解析失败，沿用当前 username
        }
      }
      this.updateForm = {
        username,
        newPassword: '',
        confirmNewPassword: ''
      }
      this.$nextTick(() => {
        if (this.$refs.updateForm) this.$refs.updateForm.clearValidate()
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  width: 100%;
}

.no-permission {
  background: #fff;
  border-radius: 4px;
  padding: 60px 24px;
  text-align: center;
  color: #909399;
}

.no-permission i {
  font-size: 48px;
  color: #e6a23c;
  margin-bottom: 12px;
}

.no-permission h2 {
  margin: 8px 0;
  font-size: 18px;
  color: #303133;
  font-weight: 500;
}

.account-card >>> .el-card__header {
  padding: 12px 16px;
}

.card-header {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.pwd-form {
  padding: 10px 0 0;
  max-width: 520px;
}
</style>
